import { AnyAction } from "redux";
import { ClearWhatsappConversations, GetWhatsappConversations, PostWhatsappUser } from "../../../actionTypes/whatsapp";

export function whatsappCode(state: string | null = null, action: AnyAction): string | null {
  switch (action.type) {
    case PostWhatsappUser.SUCCESS:
      return action.payload.checkpoint.qrcode;
    default:
      return state;
  }
}

export function whatsappConversations(state: any[] = [], action: AnyAction): any[] {
  switch (action.type) {
    case GetWhatsappConversations.SUCCESS:
      return action.payload;
    case ClearWhatsappConversations.REQUEST:
      return [];
    default:
      return state;
  }
}
